"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ScoreDetailsSideNavItem = exports.ScoreDetailsSideNav = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
var _pageTitles = require("../../go/components/common/pageTitles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var mergeItem = function mergeItem(score, refItems) {
  var itemRef = _lodash.default.find(refItems, function (ref) {
    return ref.itemCode == score.part;
  }) || {};
  var name = itemRef.name;
  return {
    part: score.part,
    name: name ? name : score.part,
    partId: score.partId
  };
};
var ScoreDetailsSideNav = function ScoreDetailsSideNav(props) {
  var scores = props.scores,
    refItems = props.refItems,
    spot = props.spot,
    currentIndent = props.currentIndent,
    activityOrder = props.activityOrder,
    fundingStreams = props.fundingStreams;
  if (refItems === undefined) {
    return null;
  }
  var items = [];
  var groupedScoresByPart = _lodash.default.groupBy(scores, 'partId');
  var knownParts = _lodash.default.size(groupedScoresByPart);
  var mappedScores = _lodash.default.map(groupedScoresByPart, function (partScores, partId) {
    var scoreObj = _lodash.default.find(partScores, function (score) {
      return !_lodash.default.isEmpty(score.part);
    });
    var part = _lodash.default.get(scoreObj, 'part');
    return {
      part: part,
      partId: partId
    };
  });
  _lodash.default.forEach(mappedScores, function (score, index) {
    var mergedPart = mergeItem(score, refItems);
    var path = "".concat(index);
    var navIndex = _lodash.default.findIndex(activityOrder, function (act) {
      return mergedPart.part === act;
    });
    navIndex = navIndex > -1 ? navIndex : knownParts++;
    items[navIndex] = /*#__PURE__*/_react.default.createElement(ScoreDetailsSideNavItem, {
      key: "".concat(path, "-").concat(score.partId),
      refItems: refItems,
      spot: spot,
      currentIndent: currentIndent,
      item: mergedPart,
      sourcePath: path,
      itemKey: score.partId,
      fundingStreams: fundingStreams
    });
  });
  return _lodash.default.filter(items, function (item) {
    return item != null;
  });
};
exports.ScoreDetailsSideNav = ScoreDetailsSideNav;
var ScoreDetailsSideNavItem = function ScoreDetailsSideNavItem(props) {
  var item = props.item,
    currentIndent = props.currentIndent,
    sourcePath = props.sourcePath,
    itemKey = props.itemKey,
    fundingStreams = props.fundingStreams;
  var currPath = "".concat(sourcePath, "-children-").concat(itemKey); // matches pattern in ItemDispatch
  var name = _lodash.default.get(item, 'name');
  var classes = "item textSmall indent_".concat(currentIndent, " leftBar");
  var dataIdLink = "item-".concat(currPath);
  var projectName = _lodash.default.get(fundingStreams, "".concat(item.partId, ".additionalInformation.projectName"), '');
  return /*#__PURE__*/_react.default.createElement("div", {
    key: name
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Menu.Item, {
    name: name,
    onClick: function onClick() {
      document.title = "".concat(_pageTitles.HOME, " - ").concat(name);
    },
    key: name,
    as: "a",
    active: false,
    href: '#' + dataIdLink,
    className: classes,
    title: name
  }, name, " ", projectName));
};
exports.ScoreDetailsSideNavItem = ScoreDetailsSideNavItem;
var _default = ScoreDetailsSideNav;
exports.default = _default;